export const enum Domain {
  APP = 'app',
  BUILDER = 'builder',
}

export const PROD_LINKS = {
  [Domain.APP]: 'https://quiz.luvly.care/',
  [Domain.BUILDER]: 'https://face.luvly.care/',
}

export const STAGE_LINKS = {
  [Domain.APP]: 'https://face-yoga-ws.gistage.com/',
  [Domain.BUILDER]: 'https://test-luvly.gistage.com/',
}

export const FUNNEL_LAB_COHORT_FIRST_PAGE = 'refund-intro-meta'

export const FUNNEL_LAB_COHORT = 'luvly_fl_ref'
